import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/newsletter")({
  component: lazyRouteComponent(() => import("./-pages/admin.newsletter")),
  head: () => ({
    meta: [
      { title: "مشتركو النشرة البريديّة — إدارة" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
